import React from 'react'
import { useMarketContext } from 'contexts/MarketContext'
import { useTranslation } from 'lib/i18n'
import config from 'lib/nextConfig'
import { DefaultSeo } from 'next-seo'

import usePath from 'hooks/usePath'

import ogShareDefaultImage from './og-share-default.jpg'

const DefaultHeadTags = () => {
  const { market, markets } = useMarketContext()
  const { t } = useTranslation()
  const path = usePath()

  const { selectedLanguage, selectedMarket } = market
  const webbAppUrl = config.WEBAPP_URL

  let url
  let languageAlternates = []

  if (selectedMarket) {
    url = `${webbAppUrl}/${selectedMarket.id}/${selectedLanguage.code}${path.nakedPath}`
    if (
      !path.nakedPath.startsWith('/profile') &&
      !path.nakedPath.startsWith('/page')
    ) {
      languageAlternates = markets
        .filter((mrkt) => mrkt.showInSitemap)
        .map((mrkt) => {
          if (mrkt.id === 'global') {
            return {
              hrefLang: 'en',
              href: `${webbAppUrl}/global/en${path.nakedPath}`,
            }
          }

          return {
            hrefLang: `${mrkt.defaultLanguage.code}-${mrkt.id}`,
            href: `${webbAppUrl}/${mrkt.id}/${mrkt.defaultLanguage.code}${path.nakedPath}`,
          }
        })
    }
  } else {
    url = webbAppUrl
  }

  // Recommended by Google for auto redirection
  // https://support.google.com/webmasters/answer/189077?hl=en
  const xDefault = {
    hrefLang: 'x-default',
    href: webbAppUrl,
  }

  return (
    <>
      <DefaultSeo
        description={t(
          'app.meta.description',
          "Get personalised videos from your favourite profiles! Choose between superstars and local celebrities. On memmo, you'll find something for all occasions!",
        )}
        canonical={path.isBase ? webbAppUrl : url}
        languageAlternates={[...languageAlternates, xDefault]}
        openGraph={{
          site_name: 'memmo',
          description: t(
            'app.og.description',
            "Get personalised videos from your favourite profiles! Choose between superstars and local celebrities. On memmo, you'll find something for all occasions!",
          ),
          type: 'website',
          locale: market.selectedLanguage?.iso || 'en_GB',
          images: [{ url: `${webbAppUrl}${ogShareDefaultImage}` }],
          url,
        }}
      />
    </>
  )
}

export default DefaultHeadTags
